/*
 * Public API Surface of Header Component
 */

export * from './header.module';
export * from './components/header/header.component';
export * from './models/header-config.model';
export * from './models/header-tab-option.model';
export * from './models/header-tab.model';
export * from '../common/models/link.model';
